var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ba-franchise-index-v5"},[(this.view.IS_AMBASSADOR || this.view.IS_AMBASSADOR_PLUS)?_c('links-user-v4',{attrs:{"props":this.view}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"box-title-copy"},[_c('div',{staticClass:"header",domProps:{"innerHTML":_vm._s(this.view.translation.fs5_affiliate_dashboard)}}),_vm._v(" "),_c('div',{staticClass:"header-link"},[_c('fs5-input-copy',{attrs:{"view":['',_vm.affiliateLink,this.view.translation.copied],"styleType":'link-affiliate',"tooltip":this.view.translation.share_link_tooltip,"tooltipPosition":'right'}}),_vm._v("\n              "+_vm._s(_vm.decodeString(_vm.view.translation.normalLinksUser.your_affiliate_link) + '/ID: ' + _vm.view.dados_usuario_office.id)+"\n            ")],1)]),_vm._v(" "),(this.view.associate_tokens)?_c('associate-tokens',{attrs:{"translations":this.view.translation.associate_tokens,"data":this.view.associate_tokens}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content"},[_c('fs5-shared-collapse',{attrs:{"view":{
                    title: _vm.view.translation.fs5_dashboard_builderall_tutorial,
                    content: {
                        translation:{
                            header: _vm.view.translation.header,
                            coming_soon: _vm.view.translation.coming_soon,
                            new: _vm.view.translation.new
                        },
                        urls: _vm.view.propsNewIndex.url_video_rank,
                        show_is_new_badge: _vm.view.propsNewIndex.url_video_show_new_badge,
                    }
                }},scopedSlots:_vm._u([{key:'content',fn:function(props){return _c('div',{},[_c('fs5-dashboard-tutorial',{attrs:{"view":props.content}})],1)}}],null,true)}),_vm._v(" "),_c('fs5-estimated-earns',{attrs:{"view":{
                translation: this.view.translation.earningsForecast,
                cards: [
                    {
                        title: ((_vm.view.translation.earningsForecast.earnings_forecast_value_label) + " (BRL)"),
                        value: _vm.view.forecast_comissions.commission_previous_BRL
                    },
                    {
                        title: ((_vm.view.translation.earningsForecast.earnings_forecast_value_label) + " (EUR)"),
                        value: _vm.view.forecast_comissions.commission_previous_EUR
                    },
                    {
                        title: ((_vm.view.translation.earningsForecast.earnings_forecast_value_label) + " (USD)"),
                        value: _vm.view.forecast_comissions.commission_previous_USD
                    }
                ]
            }}}),_vm._v(" "),_c('fs5-quick-links',{attrs:{"view":{
                    header: {
                        title: this.view.autoresponder.translations.fs5_quick_links,
                        tooltip: this.view.autoresponder.translations.fs5_quick_links_tooltip,
                        showTooltip: false
                    },
                    buttons: _vm.quickLinksButtons
                }}}),_vm._v(" "),_c('fs5-link-generator',{attrs:{"view":{
                header: {
                    title: this.view.translation.link_generator.link_generator,
                    tooltip: this.view.translation.fs5_link_generator_tooltip,
                    showTooltip: false
                },
                access_short_url: this.view.routes.access_short_url,
                can_access_short_url: this.view.can_access_short_url,
                buttons: _vm.linkGeneratorButtons
            }}}),_vm._v(" "),(_vm.view.dados_usuario_office.affiliate_type == 'PRO')?_c('fs5-funnel-club',{attrs:{"view":{
                    header: {
                        title: this.view.translation.button_onboarding_funnel,
                        tooltip: this.view.translation.fs5_funnel_club_tooltip,
                        showTooltip: false
                    },
                    content: {
                        text: this.view.translation.fs5_funnel_club_text,
                        button: {
                            label: this.view.translation.fs5_funnel_club_button,
                            textTransformType: 'capitalize',
                            btnType: 'primary',
                            link: this.view.urls.rota_office_onboarding_funnel
                        }
                    }
                }}}):_vm._e(),_vm._v(" "),_c('fs5-earnings',{attrs:{"view":{
                    header: {
                        title: this.view.translation.allValuesUser.earnings,
                        tooltip: this.view.translation.allValuesUser.label_tooltip_earnings
                    },
                    routes: this.view.routes,
                    userToken: this.view.data.user_token,
                    buttons:[
                        {
                            label: this.view.translation.allValuesUser.this_month,
                            textTransformType: 'capitalize',
                            btnType: '',
                        },
                        {
                            label: this.view.translation.allValuesUser.last_month,
                            textTransformType: 'capitalize',
                            btnType: '',
                        },
                        {
                            label: this.view.translation.allValuesUser.last_3_month,
                            textTransformType: 'capitalize',
                            btnType: '',
                        },
                        {
                            label: this.view.translation.allValuesUser.last_6_month,
                            textTransformType: 'capitalize',
                            btnType: '',
                        },
                        {
                            label: this.view.translation.allValuesUser.all_time,
                            textTransformType: 'capitalize',
                            btnType: '',
                        } ],
                    cards: [
                        { /* card 1 */
                            title: this.view.translation.allValuesUser.all_earnings,
                            content1: [
                                {
                                    text: this.view.translation.allValuesUser.all_leads,
                                    value: '0'
                                },
                                {
                                    text: this.view.translation.allValuesUser.all_active_leads,
                                    value: '0'
                                },
                                {
                                    text: this.view.translation.allValuesUser.number_of_all_affiliates,
                                    value: '0'
                                }
                            ],
                            content2: [
                                {
                                    text: 'USD',
                                    value: '0'
                                },
                                {
                                    text: 'EUR',
                                    value: '0'
                                },
                                {
                                    text: 'BRL',
                                    value: '0'
                                }
                            ]
                        },
                        { /* card 2 */
                            title: this.view.translation.allValuesUser.first_tier_leads,
                            content1: [
                                {
                                    text: this.view.translation.allValuesUser.all_leads,
                                    value: '0'
                                },
                                {
                                    text: this.view.translation.allValuesUser.all_active_leads,
                                    value: '0'
                                },
                                {
                                    text: this.view.translation.allValuesUser.number_of_all_affiliates,
                                    value: '0'
                                }
                            ],
                            content2: [
                                {
                                    text: 'USD',
                                    value: '0'
                                },
                                {
                                    text: 'EUR',
                                    value: '0'
                                },
                                {
                                    text: 'BRL',
                                    value: '0'
                                }
                            ]
                        },
                        { /* card 3 */
                            title: this.view.translation.allValuesUser.tier_2_sales,
                            content1: [
                                {
                                    text: this.view.translation.allValuesUser.all_leads,
                                    value: '0'
                                },
                                {
                                    text: this.view.translation.allValuesUser.all_active_leads,
                                    value: '0'
                                },
                                {
                                    text: this.view.translation.allValuesUser.number_of_all_affiliates,
                                    value: '0'
                                }
                            ],
                            content2: [
                                {
                                    text: 'USD',
                                    value: '0'
                                },
                                {
                                    text: 'EUR',
                                    value: '0'
                                },
                                {
                                    text: 'BRL',
                                    value: '0'
                                }
                            ]
                        } ]
                }}}),_vm._v(" "),_c('fs5-current-earnings',{attrs:{"view":{
                header: {
                    title: this.view.translation.currentEarnings.label_seus_ganhos,
                    tooltip: this.view.translation.currentEarnings.fs5_current_earnings_tooltip,
                    showTooltip: false
                },
                button: {
                    label: this.view.translation.currentEarnings.label_get_paid,
                    textTransformType: 'capitalize',
                    btnType: 'primary',
                    link: this.view.urls.rota_ganhos
                },
                cards: [
                    {
                        title: this.view.translation.currentEarnings.waiting,
                        tooltip: this.view.translation.currentEarnings.dash_business_tooltip_waiting,
                        earns: [
                            {
                                text:  'USD',
                                value: ("$ " + ((_vm.view.totais_ganhos.USD.A_RECEBER ? _vm.view.totais_ganhos.USD.A_RECEBER.valor : 0)))
                            },
                            {
                                text:  'EUR',
                                value: ("€ " + ((_vm.view.totais_ganhos.EUR.A_RECEBER ? _vm.view.totais_ganhos.EUR.A_RECEBER.valor : 0)))
                            },
                            {
                                text:  'BRL',
                                value: ("R$ " + ((_vm.view.totais_ganhos.BRL.A_RECEBER ? _vm.view.totais_ganhos.BRL.A_RECEBER.valor : 0)))
                            } ]
                    },
                    {
                        title: this.view.translation.currentEarnings.available,
                        tooltip: this.view.translation.currentEarnings.dash_business_tooltip_available,
                        earns: [
                            {
                                text:  'USD',
                                value: ("$ " + ((_vm.view.totais_ganhos.USD.NAO ? _vm.view.totais_ganhos.USD.NAO.valor : 0)))
                            },
                            {
                                text:  'EUR',
                                value: ("€ " + ((_vm.view.totais_ganhos.EUR.NAO ? _vm.view.totais_ganhos.EUR.NAO.valor : 0)))
                            },
                            {
                                text:  'BRL',
                                value: ("R$ " + ((_vm.view.totais_ganhos.BRL.NAO ? _vm.view.totais_ganhos.BRL.NAO.valor : 0)))
                            } ]
                    },
                    {
                        title: this.view.translation.currentEarnings.requested,
                        tooltip: this.view.translation.currentEarnings.dash_business_tooltip_requested,
                        earns: [
                            {
                                text:  'USD',
                                value: ("$ " + ((_vm.view.totais_ganhos.USD.SOLICITADO ? _vm.view.totais_ganhos.USD.SOLICITADO.valor : 0)))
                            },
                            {
                                text:  'EUR',
                                value: ("€ " + ((_vm.view.totais_ganhos.EUR.SOLICITADO ? _vm.view.totais_ganhos.EUR.SOLICITADO.valor : 0)))
                            },
                            {
                                text:  'BRL',
                                value: ("R$ " + ((_vm.view.totais_ganhos.BRL.SOLICITADO ? _vm.view.totais_ganhos.BRL.SOLICITADO.valor : 0)))
                            } ]
                    },
                    {
                        title: this.view.translation.currentEarnings.paid,
                        tooltip: this.view.translation.currentEarnings.dash_business_tooltip_paid,
                        earns: [
                            {
                                text:  'USD',
                                value: ("$ " + ((_vm.view.totais_ganhos.USD.SIM ? _vm.view.totais_ganhos.USD.SIM.valor : 0)))
                            },
                            {
                                text:  'EUR',
                                value: ("€ " + ((_vm.view.totais_ganhos.EUR.SIM ? _vm.view.totais_ganhos.EUR.SIM.valor : 0)))
                            },
                            {
                                text:  'BRL',
                                value: ("R$ " + ((_vm.view.totais_ganhos.BRL.SIM ? _vm.view.totais_ganhos.BRL.SIM.valor : 0)))
                            }
                        ]
                    } ]
            }}}),_vm._v(" "),_c('fs5-disclosure',{attrs:{"view":{
                header: {
                    title: this.view.translation.graphicDisclosures.fs5_disclosure_title,
                    tooltip: this.view.translation.graphicDisclosures.fs5_disclosure_tooltip,
                    showTooltip: false
                },
                content: {
                    left: {
                        title: this.view.translation.graphicDisclosures.fs_disclosure_left_title,
                        subtitle: this.view.translation.graphicDisclosures.fs_disclosure_left_subtitle,
                        chartLabel: this.view.translation.graphicDisclosures.fs_disclosure_left_chart_label,
                        buttons: [
                            {
                                label: this.view.translation.graphicDisclosures.today,
                                textTransformType: 'capitalize',
                                btnType: 'white2',
                                btnTypeActive: 'default',
                                period: 'day'
                            },
                            {
                                label: this.view.translation.graphicDisclosures.month,
                                textTransformType: 'capitalize',
                                btnType: 'white2',
                                btnTypeActive: 'default',
                                period: 'month'
                            },
                            {
                                label: this.view.translation.graphicDisclosures.year,
                                textTransformType: 'capitalize',
                                btnType: 'white2',
                                btnTypeActive: 'default',
                                period: 'year'
                            } ]
                    },
                    right: {
                        labelUrl: this.view.translation.graphicDisclosures.label_url,
                        access: this.view.translation.graphicDisclosures.access,
                        registration: this.view.translation.graphicDisclosures.registration,
                        disclosureEmpty: this.view.translation.graphicDisclosures.disclosure_empty
                    }
                },
                buttons: [
                    {
                        label: this.view.translation.general.label_click_for_rank_definitions,
                        textTransformType: 'capitalize',
                        btnType: 'white',
                        link: this.view.urls.rota_ranking
                    },
                    {
                        label: this.view.translation.general.label_compensation_plan_details,
                        textTransformType: 'capitalize',
                        btnType: 'white',
                        link: this.view.urls.rota_affiliates
                    } ]
            }}}),_vm._v(" "),_c('fs5-affiliate-profile',{attrs:{"view":{
                header: {
                    title: this.view.translation.start_here_resources_title,
                    tooltip: '',
                    showTooltip: false
                },
                content: {
                    left: {
                        title: this.view.translation.start_here_bio_label,
                        remainingCharacter: this.view.translation.label_caracter_restante,
                        button: {
                            label: this.view.translation.button_salvar,
                            textTransformType: 'capitalize',
                            btnType: 'primary',
                            link: this.view.routes.rota_office_handler_usuarios_complement
                        }
                    },
                    right: {
                        title: this.view.translation.start_here_gravatar_label,
                        emailLabel: this.view.translation.email,
                        buttons: [
                            {
                                label: this.view.translation.start_here_setup_gravatar,
                                textTransformType: 'capitalize',
                                btnType: 'primary',
                                link: 'https://en.gravatar.com/connect/'
                            },
                            {
                                label: this.view.translation.button_salvar,
                                textTransformType: 'capitalize',
                                btnType: 'default',
                                disabled: true
                            } ],
                        affiliateLink: {
                            label: this.view.translation.normalLinksUser.your_affiliate_link,
                            link: this.view.link_user ? this.view.link_user : false,
                            copy: this.view.translation.normalLinksUser.copy
                        }
                    }
                },
                dados_usuario_office: this.view.dados_usuario_office
            }}})],1)],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a4af498","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/office/js/components/franchise_v5/affiliate_dashboard/index.vue
// module id = TKAQ
// module chunks = 0